import React from "react"
import { Helmet } from "react-helmet"

const siteUrl = "https://www.docteurphilipperoure.com"

// Balises hreflang réciproques d'une page et de sa traduction.
// Rien n'est rendu si la page n'a pas d'équivalent dans l'autre langue.
const Hreflang = ({ fr, en }) => {
  if (!fr || !en) return null
  return (
    <Helmet>
      <link rel="alternate" hreflang="fr" href={`${siteUrl}${fr}`} />
      <link rel="alternate" hreflang="en" href={`${siteUrl}${en}`} />
      <link rel="alternate" hreflang="x-default" href={`${siteUrl}${fr}`} />
    </Helmet>
  )
}

export default Hreflang
